import React from 'react';

export default function ConnectingLine({ short }) {
  return (
    <div className={`flex justify-center ${short ? 'my-2' : 'my-4'}`}>
      <div className={`w-0.5 bg-gradient-to-b from-indigo-200 to-indigo-400 ${short ? 'h-6' : 'h-12'}`} />
    </div>
  );
}
